const skillsBackend = [
    {
        id: "wdc001",
        title: "Node JS"
    },
    {
        id: "wdc002",
        title: "Express JS"
    },
    {
        id: "wdc003",
        title: "Mongoose ODM"
    },
    {
        id: "wdc004",
        title: "MongoDB Atlas"
    },
    {
        id: "wdc005",
        title: "PHP"
    },
    {
        id: "wdc006",
        title: "MySQL"
    },
    {
        id: "wdc007",
        title: "Turbo C"
    },
    {
        id: "wdc009",
        title: "C++"
    },
    {
        id: "wdc010",
        title: "Visual Basic"
    },
    {
        id: "wdc011",
        title: "PostgreSQL"
    },
    {
        id: "wdc012",
        title: "Sequelize.JS"
    },
    {
        id: "wdc013",
        title: "Redis"
    },
    {
        id: "wdc014",
        title: "GraphQL"
    }
]

export default skillsBackend;
